import ArmsRum from '@arms/rum-browser/dist/browser-sdk';
import type { IBrowserConfig } from '@arms/rum-browser/lib/types/client';
export interface IBizUserInfo {
    /**
     * patsnap用户ID
     */
    patsnapUserId?: string;
    /**
     * 用户标签,可以是用户的角色、套餐、权限等信息
     * https://help.aliyun.com/zh/arms/user-experience-monitoring/web-h5-sdk-configuration-reference?#tX9bN
     */
    userTags?: string;
}
export interface IBizConfig {
    /**
     * 用户信息
     */
    userInfo?: IBizUserInfo;
}

/**
 * ARMS实例
 */
let __bl: typeof ArmsRum | null = null;

/**
 * 初始化ARMS
 * @param browserConfig 原始配置,配置说明详见https://help.aliyun.com/zh/arms/user-experience-monitoring/web-h5-sdk-configuration-reference
 * @param bizConfig 业务配置
 * @returns 
 */
export function initARMS(browserConfig: IBrowserConfig, bizConfig?: IBizConfig): typeof ArmsRum | null {
    if(__bl) {
        return __bl;
    }

    if(!browserConfig?.pid || !browserConfig?.endpoint) {
        console.warn('ARMS init error: pid or endpoint is required');
        return null;
    }

    if(browserConfig?.pid?.startsWith('{{') || browserConfig?.endpoint?.startsWith('{{')) {
        console.warn('ARMS init error: pid or endpoint got wrong value: ', browserConfig);
        return null;
    }

    try {
        const defaultConfig: Pick<IBrowserConfig, 'tracing'> = {
            tracing: {
                enable: true,
                sample: 100,
                tracestate: true,
                baggage: false,
                allowedUrls: [
                    {
                        match: (url: string = '') => {
                            const [_url] = url.split('?');
                            const regex = /\.(html|js|css|woff|png)$/;
                            if(regex.test(_url)) return false;

                            if(_url?.includes('.zhihuiya.com')) return true;
                            if(_url?.includes('.patsnap.com')) return true;
                            if(_url?.includes('.patsnap.eu')) return true;
                            return false;
                        },
                        propagatorTypes: ['b3'],
                    },
                ],
            },
        };
        __bl = ArmsRum.init({
            ...defaultConfig,
            ...browserConfig,
            ..._formateBizConfig2ArmsConfig(bizConfig),
        });

    } catch (e) {
        console.error('ARMS init error: ', e);
    }

    console.info('ARMS inited: ', browserConfig);
    return __bl;
}

/**
 * 设置用户信息
 * @param userInfo 
 * @returns 
 */
export function setUserInfo(userInfo:IBizUserInfo) {
    if (!__bl) {
        console.warn('ARMS is not inited');
        return;
    }
    const config = __bl.getConfig();
    __bl.setConfig({
        ...config,
        user: _formateBizUserInfo2ArmsUserInfo(userInfo)
    })
}

/**
 * 格式化业务配置
 * @param bizConfig 
 * @returns 
 */
function _formateBizConfig2ArmsConfig(bizConfig?: IBizConfig) {
    const config: Pick<IBrowserConfig, 'user'> = {}
    if (bizConfig?.userInfo) {
        config.user = _formateBizUserInfo2ArmsUserInfo(bizConfig.userInfo)
    }
    return config
}

/**
 * 格式化用户信息
 * @param userInfo 
 * @returns 
 */
function _formateBizUserInfo2ArmsUserInfo(userInfo: IBizUserInfo): IBrowserConfig['user'] {    
    const armsUser: IBrowserConfig['user'] = {}
    if (userInfo.patsnapUserId) {
        // 如果需要关联业务自有账号体系，建议使用user.name或者user.tags ，而不是修改user.id。强制覆盖SDK生成的user.id ，会影响UV的计算。
        // https://help.aliyun.com/zh/arms/user-experience-monitoring/web-h5-sdk-configuration-reference?#42a688e04fbco
        armsUser.name = _formatePatSnapUid2ArmsUserName(
            userInfo.patsnapUserId
        );
    }
    if (userInfo.userTags) {
        armsUser.tags = userInfo.userTags;  
        
    }
    return armsUser
}

/**
 * 格式化用户ID
 * @param id 
 * @returns 
 */
function _formatePatSnapUid2ArmsUserName(id?: string) {
    if (!id) return '';
    // 添加前缀是为了在阿里云arms系统中一眼就能看出这是我们自己的uid
    return `patsnapuid_${id}`;
}